import React from 'react';

const LogoAppleSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 6.8c-1.6-.2-3.1.9-3.8.9-.8 0-2-.9-3.3-.9-1.7 0-3.3 1-4.1 2.5C2.9 12.5 4.2 17 6 19.5c.8 1.2 1.9 2.6 3.2 2.5 1.3 0 1.7-.8 3.3-.8 1.5 0 2 .8 3.3.8 1.4 0 2.2-1.2 3.1-2.5 1-1.4 1.4-1.9 1.4-2 0 0-2.6-1.9-2.7-4.9 0-2.5 2.1-3.8 2.2-3.8-1.3-1.7-3.2-1.9-3.8-2zM16 2c-1 0-2.2.7-2.9 1.5-.7.7-1.2 1.9-1.1 3.1 1.1.1 2.3-.6 3-1.4.6-.8 1.1-2 1-3.2z"
        />
    </svg>
);

LogoAppleSvg.displayName = 'LogoAppleSvg';
export default LogoAppleSvg;
